export default __webpack_public_path__ + "static/media/Tyra_9781408316764.03218a1a.jpg";